import { render } from "./TheKeyboard.vue?vue&type=template&id=d1727942&scoped=true"
import script from "./TheKeyboard.vue?vue&type=script&lang=js"
export * from "./TheKeyboard.vue?vue&type=script&lang=js"

import "./TheKeyboard.vue?vue&type=style&index=0&id=d1727942&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d1727942"

export default script